// extracted by extract-css-chunks-webpack-plugin
module.exports = {"socialIconWrapper":"footerSocialIcon__socialIconWrapper--zEHlG","socialIcon":"footerSocialIcon__socialIcon--1v_gp"};